import { API_PATH_INTERNAL } from '@/lib/constants'
import apiService from '@/lib/services/apiService'
import { CreateOrUpdateFcaServiceRequest } from '@/types/requests/fca-services'

class FcaServiceService {
  private endpoint = `${API_PATH_INTERNAL}/fca-services`

  async createFcaService(request: CreateOrUpdateFcaServiceRequest) {
    const response = await apiService.post(this.endpoint, request)

    return response.data
  }

  async updateFcaService(
    fcaServiceId: number,
    request: CreateOrUpdateFcaServiceRequest,
  ) {
    const response = await apiService.patch(
      `${this.endpoint}/${fcaServiceId}`,
      request,
    )

    return response.data
  }
}

const fcaServiceService = new FcaServiceService()

export default fcaServiceService
